import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { SSearchFilterGroup, SSearchFilterGroupOptions } from "../../../styles/StyledSearchFilters";
import { SearchFiltersType, useSearchContext } from "../../../context/search";
import { SearchFilterType } from "../SearchFilters";
import { Types } from "../../../context/search/reducers";
import { roles } from "../../../constants/role";
import { SearchFiltersField } from "../SearchFiltersField";

type SearchFiltersListProps = {
	filters: SearchFilterType[];
};

export const SearchFiltersList = ({ filters }: SearchFiltersListProps) => {
	const { t } = useTranslation();

	const {
		dispatch,
		state: { filters: searchFilters },
	} = useSearchContext();

	const handleSubmit = (values: SearchFiltersType) => {
		dispatch({ type: Types.SetFilters, payload: { filters: values } });
	};

	const mapped = filters.map((group) => (
		<SSearchFilterGroup key={group.name} id={`${group.name}-group`}>
			<h5>{t(`${group.name}`)}</h5>
			{group.options.length > 0 && (
				<SSearchFilterGroupOptions role="group" aria-labelledby="checkbox-group">
					{group.options.map((option) => (
						<li key={option.name}>
							<SearchFiltersField type="checkbox" group={group} option={option} />
						</li>
					))}
				</SSearchFilterGroupOptions>
			)}
		</SSearchFilterGroup>
	));
	return (
		<Formik initialValues={searchFilters} onSubmit={handleSubmit}>
			{(form) => (
				<Form onChange={form.submitForm}>
					{mapped}
					<SSearchFilterGroup>
						<h5>{t("date")}</h5>
						<SSearchFilterGroupOptions>
							<SearchFiltersField type="date" name="startDate" />
							<SearchFiltersField type="date" name="endDate" />
						</SSearchFilterGroupOptions>
					</SSearchFilterGroup>
					<SSearchFilterGroup>
						<h5>{t("role")}</h5>
						<SSearchFilterGroupOptions role="group" aria-labelledby="checkbox-group">
							{roles.map((option) => (
								<li key={option}>
									<SearchFiltersField type="checkbox" group={{ name: "role" }} option={{ id: option, name: option }} />
								</li>
							))}
						</SSearchFilterGroupOptions>
					</SSearchFilterGroup>
				</Form>
			)}
		</Formik>
	);
};
